exports.f = Object.getOwnPropertySymbols;



// WEBPACK FOOTER //
// D:/a/vallentuna-public/vallentuna-public/node_modules/core-js/modules/_object-gops.js